//console.log('anfilterv12-v3.js- updated');
//alert('Cart update-1');
//setup before functions
$('.cls_initem').css('height',($(window).height()*0.9)+'px');
function remove_update(id){
   delete ex_items[proid_varid[id]];
   delete offer_items[proid_varid[id]];
   var pid = proid_varid[id];
   
    var obj = $('#fld_'+pid+', #serfld_'+pid+' ,#offld_'+pid);//divser_new_5133978435718
    obj.val('0');
	obj=$('#btnadd_grid-product-form--'+ pid+' ,#btnadd, #seritem_'+pid);
	obj.text('Add to Cart');	
	obj = $('#div_new_'+pid+', #divof_new_'+pid+',#divser_new_'+pid);
    obj.fadeIn(300);
	obj = $('#div_mul_'+pid+', #divof_mul_'+pid+' ,#divser_mul_'+pid);
    obj.hide();// 
	$(document).find('[data-btmmess-'+pid+']').text('');
    reset_minicart();
}
function reset_minicart(){
	/*$('.mc-offer-box').each(function(index, element) {
        alert($(this).html());
    });*/
	$( "div" ).remove( ".mc-offer-box" );
	mcart_offer_update();
}
var searchBoxObj = null;
if($(window).width() > 1199){
   searchBoxObj = $('.cls_mainsearch').eq(1);
   insert_mic();
}else{
   searchBoxObj = $('.cls_mainsearch').eq(0);
}
var all_items;
var ini_tags=new Array();
var store_id;
var fil_scat,fil_mcat,fil_brnd;
var ini_sta=false;
var scn_eble=false;
var san_started=false;
var updateCrtpos=0;
var errimg=new Array();
var erradditems=new Array();
var gather_allrec_var = true;
var iniStore;
var scnt;
var all_offer_exi;
var all_offer_id;
var offer_ini = false;
//get_all_offers();
function get_all_offers(){
   if(all_offer_exi==null){
	    $.ajax({
      url:"https://kugans.co/offer/get_offer.php?_ans=1",
      dataType: "jsonp",
      jsonp: "callback",
      success: function (a) {
         var obj = JSON.parse(a.message);	
		 all_offer_exi = new Array();	
		 all_offer_id = new Array();
		 //all_offer = JSON.parse(all_offer);
		 //console.log(obj);
		 //send_to_draft();
		 //d[1]
		 //alert(obj.length);
		 for(var i=0;i<obj.length;i++){
				all_offer_exi[obj[i].id]=obj[i].name; 
			    all_offer_id[obj[i].id]=obj[i].id; 
		 }
		 //console.log(all_offer_exi);
      }
   });
   }
}
searchBoxObj.blur(function(){
   //searchBoxObj.keyup();   
});
function test_offer(){
	//update_offer_qty();
	//alert('Updating offer');
	$('.cls_searchpop .cls_offmsg .clsoffer_33').html('Offer Test');
}
//$(document).ready(function(){
  $(document).mousemove(function(event){
    m_move();
	if(offer_ini){
	   //console.log('Offer Initiated');
	  update_offer_qty();
	   //setInterval(function(){ update_offer_qty(); }, 3000);
	   offer_ini=false;
	}
  });
//});
var m_moved=false;
function m_move(){
  if(m_moved)return;
  m_moved=true;
  //console.log('Mouse Moved');
  init_search_rslt();
}
searchBoxObj.click(function(){
  console.log('searchBoxObj called');
  $('.nav_up,.cart-side-btn').hide();
    if(!scn_eble && !san_started){
      console.log('searchBoxObj check1');
        m_move();
      console.log('searchBoxObj check2');
		init1();
      console.log('searchBoxObj check3');
		san_started=true;
        gather_allrec();	
      console.log('searchBoxObj check4');
	}else{
		console.log('Normal start');
		$('.cls_searchpop').fadeIn(300);
		
	}
  console.log('searchBoxObj check5');
  $('body').addClass('openspop');
  console.log('searchBoxObj check6');
   halo.updateProductCardUI();
});
$(document).on('click','.custom-search-pop a', function(e){
  e.preventDefault();
  $('body').addClass('openspop');
  if(!scn_eble && !san_started){
    init1();
    san_started=true;
    gather_allrec();
  }else{
    $('.cls_searchpop').fadeIn(300);
  }
});
var in_carritems;
check_cart_item();
function check_cart_item(){
   if(!all_items){
	   //console.log('Looping');
	   setTimeout("check_cart_item()",1000);
	   return;
   }
    in_carritems = new Array();
	delete_uaitems();
}
//var reCnt;
function delete_uaitems(){
   for(var i=0;i<all_items.length;i++){
	   //console.log(ex_items[all_items[i]['proid']]+' '+all_items[i]['proid']);
	   if(ex_items[all_items[i]['proid']]!=null && all_items[i]['qty']<1){
		  // console.log(all_items[i]['qty']+' '+all_items[i]['hdle']);
		   in_carritems[in_carritems.length]=all_items[i]['hdle'];
	   }
   }
   if(in_carritems.length>0){
	   //reCnt=0;
	   init_deletepro(0);
   }
}
function init_deletepro(reCnt){
   $.getJSON('/products/'+in_carritems[reCnt]+'.js', function(product) {
      //alert(product.variants[0]['id']);
	  Shopify.removeItem(product.variants[0]['id'], function (cart) {
	     reCnt++;
	     if(reCnt<in_carritems.length){
	        setTimeout(function() {
               init_deletepro(reCnt);
            }, 50);	  
	     }else{
		    after_removal();
			halo.updateDropdownCart();
	     }
	  });
   });
}
function after_removal(){
	//header-cart
	var html='<div class="cls_remmsg" style="displat:none">';
	html+='<b>Cart Updated</b></div>';
	$('.header-cart').append(html);
	$('.cls_remmsg').css({
	   'position' : 'absolute',
	   'margin-left':'0px',
	   'margin-top' :'10%',
	   'padding' :'3px',
	   'border-radius':'4px',
	   'border':'1px solid #000',
	   'color':'#ff1a00'
	});
	$('.cls_remmsg').fadeIn(300,function(){
	   setTimeout("$('.cls_remmsg').fadeOut(300)",5000);
	});
	//alert('Items has been removed from the Basket');
}
$(document).on('click','.cls_altitem, .cls_smi-item', function(){
	var id=$(this).attr('id').split('_');
    let title = ''; 
    let price = ''; 
  
    if ($(this).closest('.product-shop').length) {
        title = $(this).closest('.product-shop').find('.product-title span').text().trim();
        price = $(this).closest('.product-shop').find('.prices .price').text().trim();
    }
    else if ($(this).closest('.cls_find').length) {
        title = $(this).closest('.cls_find').find('.product-bottom .product-title span').text().trim();
        const priceSpecial = $(this).closest('.cls_find').find('.product-bottom .special-price');
       const priceClsSale = $(this).closest('.cls_find').find('.product-bottom .price-regular .cls_sale');
        if (priceSpecial.length) {
            price = priceSpecial.text().trim();
        } else if(priceClsSale.length){
           price = priceClsSale.text().trim();
        } else {
            price = $(this).closest('.cls_find').find('.product-bottom .price-regular span').text().trim();
        }
      console.log('price',price);
    }
    //$("span.product-title-price").html(title+' '+price);
  
  	var html = 'Alternative Items For <span class="product-title-price">'+title+' '+price+'</span>'
	html+='<span class="close-popup"><svg aria-hidden="true" data-prefix="fal" ';
	html+='data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" ';
	html+='viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x">';
	html+='<path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.';
	html+='12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 ';
	html+='36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 ';
	html+='11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 ';
	html+='8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 ';
	html+='0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg></span>';
	html+='<span style="color: rgb(123, 192, 2); display: none;" class="cls_load">';
	html+='<img src="https://cdn.shopify.com/s/files/1/0270/7157/8246/files/loader2.gif" ';
	html+='style="height:20px"></span><span style="color: rgb(123, 192, 2);" class="cls_tick">✔</span>';
  	$('#div_altlist .promotion-heading').html(html);
   $('#div_altlist').fadeIn(300,function(){
      find_altforpage(id[1]);
   });
  
});
$('.close-popup').click(function(){
   $('#div_altlist').fadeOut(300,function(){
	   $('#div_altlist .cls_initem').html('');
	});

    $('#div_altlist').removeClass('no-items');
    halo.updateProductCardUI();
  
//   $('#div_altlist > div').addClass('cls_cont');
});
function findRep(id){
	 $('#div_altlist').fadeIn(300,function(){
      find_altforpage(id);
   });
}
function find_altforpage(id){
	if(!all_items){
	   //console.log('Alt Looing');
	   setTimeout(function() {
          find_altforpage(id);
       }, 1000);
	   return;
   }
   $('#div_altlist .cls_initem').html('');
   //$('#myModal .modal-content').fadeIn(300,function(){
	  //$('.cls_mod').show();
      var index = get_index(id);
     
   
  
      if(index!==''){
     
	     var ret = alt_item_loop(all_items[index]['filcat'].split(','),true,index);
	     ret = sort_list(ret, true,false,true);
		 //ret='';
		 if(ret==''){
           $('#div_altlist').addClass('no-items');
		   //console.log('Nof items 0 '+ret);
//            $('#div_altlist > div').removeClass('cls_cont');
			 ret='<div style="color:#fd7e14;font-size:24px; padding:15% 0">';
			 ret+='Sorry No alternative item/s found';
			 ret+='</div>';
			 $('.cls_tick').html('<span style="color:red;">&#10007;</span>');
		 }else{
			 $('.cls_tick').html('&#10004;');
		 }
		 $('#div_altlist .cls_initem').html(ret); 
         $('.cls_load').fadeOut(300,function(){
            $('.cls_tick').show();
            $('.cls_ulalt li').fadeIn(300);
	     });
      }else{
           
		  //console.log('Nof items 1 '+index);
		//  get_from_db(id,index);
         /*$('#div_altlist').addClass('no-items');
         ret='<div style="color:#fd7e14;font-size:24px; padding:15% 0">';
	     ret+='Sorry No alternative item/s found';
	     ret+='</div>';
	    $('.cls_tick').html('<span style="color:red;">&#10007;</span>');*/
     }
    
}
function get_from_db(proid,index){
   var url='https://kugans.co/search_filter/connect/get_item_proid.php';
   var para = '?_ans='+proid;
   url+=para;
   //alert(url);
   $.ajax({
      url:url,
	  dataType: "jsonp",
	  jsonp: "callback",
	  success: function (a) {
		 //alert(a.message);
         if(a.message!=''){
	        var ret = alt_item_loop(a.message.split(','),true,index);
	        ret = sort_list(ret, true,false,true);
			if(ret==''){
               $('#div_altlist').addClass('no-items');
		       //console.log('Nof items 0 '+ret);
//            $('#div_altlist > div').removeClass('cls_cont');
			   ret='<div style="color:#fd7e14;font-size:24px; padding:15% 0">';
			   ret+='Sorry No alternative item/s found';
			   ret+='</div>';
			   $('.cls_tick').html('<span style="color:red;">&#10007;</span>');
		    }else{
			   $('.cls_tick').html('&#10004;');
		    }
			$('#div_altlist .cls_initem').html(ret); 
            $('.cls_load').fadeOut(300,function(){
               $('.cls_tick').show();
               $('.cls_ulalt li').fadeIn(300);
	        });     
		 }
	  }
   });
}
function get_index(id){
   for(var i=0;i<all_items.length;i++){
	  if(all_items[i]['proid'].indexOf(id)!=-1){
		  //console.log('Matched '+i);
		  return i;
	  }
   }
   return '';
}
var tCnt, allTxt,speed,sentCnt;
var stopruntxt = false;
function runingtxt(){
   tCnt = 0;
   sentCnt=0;
   allTxt = new Array(); 
   allTxt[0] = 'Please type what you want to search';
   allTxt[1] = 'Example - fresh vegetables';
   speed = 50;
   typeWriter();
}
function typeWriter() {
  if(stopruntxt)return;
  if (tCnt <=allTxt[sentCnt].length && searchBoxObj.val()=='') {
    searchBoxObj.attr('placeholder', allTxt[sentCnt].substring(0, tCnt));
    tCnt++;
    setTimeout(typeWriter, speed);
  }else{
	 //alert(allTxt[sentCnt]);
     //alert(sentCnt);
     sentCnt++;
	 //alert(sentCnt);
	 if(sentCnt>=allTxt.length){
		 sentCnt=0;
	 }
	 setTimeout(resetRuningtxt, 10000);
  }
}
function resetRuningtxt(){
   searchBoxObj.attr('placeholder','');
   tCnt=0;
   typeWriter();
}
$( document ).ready(function() {
    insert_bcodescan();

	runingtxt();
});
$('.icon-search').mouseover(function() {
  searchBoxObj.attr('placeholder','Search by typing');
  searchBoxObj.focus();
  stopruntxt=true;
});
$( '.icon-search' ).mouseout(function() {
  searchBoxObj.attr('placeholder','Search');
  stopruntxt=false;
});
$('.cls_gmic').mouseover(function() {
  searchBoxObj.attr('placeholder','Click to search by speaking');
  stopruntxt=true;
});
$( '.cls_gmic' ).mouseout(function() {
  searchBoxObj.attr('placeholder','Search');
  stopruntxt=false;
});
$(document).on("mouseover", "#search_brdcord" , function() {
  searchBoxObj.attr('placeholder','Click to search by barcode');

  stopruntxt=true;
});
$(document).on("mouseout", "#search_brdcord" , function() {
  searchBoxObj.attr('placeholder','Search');
  stopruntxt=false;
});
function insert_mic(){
	var html ='<a href="javascript:startDictation()" ';
	html+='class="cls_gmic"><img src="https://cdn.shopify.com/';
	html+='s/files/1/0270/7157/8246/files/google_mic.png" ';
	html+='style="height:25px"></a>';
	$('.search-bar').append(html);
	$('.cls_gmic').css({
	   'margin-top':'1.5%',
	   'margin-right':'3%',
	});
}
function click_searchbtn(){
	camon=false;
	$('.cls_searchpop').hide();
	$('#startButton').click();
	if(!camon){
		searchBoxObj.attr('placeholder','Webcam not detected');
		reset_txt();
	}
}
function insert_bcodescan(){
   var html='<a id="search_brdcord" style="padding-top:7px; padding-right:5px" ';
   html+='href="javascript:click_searchbtn()">';
   html+='<img src="https://cdn.shopify.com/s/files/';
   html+='1/0270/7157/8246/files/barcodescan.png?';
   html+='v=1607353089" style="height:25px"></a>';
   $('.search-bar').append(html);
   if($(window).width() < 1199){
      $('.input-group-field').css({
	     'border':'dotted 2px #7bc002'
      });
   }
	
}
function checkmicandoff(){
   if(searchBoxObj.val()==''){
      var recognition = new webkitSpeechRecognition();
      searchBoxObj.css({
         'background-image': 'none',
	     'padding-left':'11px'
      });
	  recognition.stop();
      searchBoxObj.attr('placeholder','Sorry did not detect sound...');
   }
}
function startDictation() {
   navigator.getMedia({audio: true}, function() {
      searchBoxObj.val('');
      searchBoxObj.click();
      if(window.hasOwnProperty('webkitSpeechRecognition')) {
         setTimeout("checkmicandoff()",10000);
	     searchBoxObj.attr('placeholder','Say what you want to search');
         searchBoxObj.css({
            'background-image': 'url("https://cdn.shopify.com/s/files/1/0270/7157/8246/files/listenwave.gif?v=1607543815")',
	        'background-repeat': 'no-repeat',
            'background-size': 'auto 100%',
	        'padding-left':'13%'
         });
         var recognition = new webkitSpeechRecognition();
         recognition.continuous = false;
         recognition.interimResults = false;
         recognition.lang = "en";//"en-US" Original
         recognition.start();
         recognition.onresult = function (e) {
	     //console.log('2');
            searchBoxObj.val(e.results[0][0].transcript);
            searchBoxObj.keyup();
	        searchBoxObj.attr('placeholder','Search');
	        searchBoxObj.css({
               'background-image': 'none',
	           'padding-left':'11px'
            });
            recognition.stop();
         },
         recognition.onerror = function(e) {
            recognition.stop();
         }
      }
   }, function() {
	   searchBoxObj.attr('placeholder','Microphone not detected');
	   reset_txt();
   });
}
function reset_txt(){
	setTimeout("searchBoxObj.attr('placeholder','Search')",5000);
}
function scan_addtocart(bcode){
   bcode = bcode.trim();
   if(all_items==null){
	   setTimeout("scan_addtocart('"+bcode+"')",5000);
	   return;
   }
   var proid ='';
   for(var i=0;i<all_items.length;i++){
	   $('body').append(all_items[i]['bcode']);
	   if(parseInt(all_items[i]['bcode'])==parseInt(bcode)){
	     proid=all_items[i]['hdle'];
		 break;
	   }
   }
   //alert(proid);
   if(proid!=''){
      $.getJSON('/products/'+proid+'.js', function(product) {
		  updateCrtpos=1;
		  Shopify.addItem(product.variants[0]['id'],1, function (cart) {
             halo.updateDropdownCart();
          });
          //initiate_addtocart(product.variants[0]['id'], id[1]);
      }).fail(function() { 
	     erradditems[erradditems.length]=bcode;
	    // find_altitem(bcode);
	  });
   }else{
	  // find_altitem(bcode);
   }
}
/*$( document ).ready(function() {
    setTimeout("find_altitem('dsffs')",2000);
});*/
//find_altitem('8904064602502A');
function find_altitem(bcode){
   searchBoxObj.click();
   var para = '?_ans='+bcode;
   var url='https://kugans.co/search_filter/connect/get_altbcode.php';
   url+=para;
   $.ajax({
      url:url,
	  dataType: "jsonp",
	  jsonp: "callback",
	  success: function (a) {
         if(a.message=='-1'){
		   // nonrst_extsearch(bcode);
		 }else{
		    var obj = JSON.parse(a.message);
			foundAlt_items(obj);  
	     }
	   }
   });
}
function foundAlt_items(obj){
   store_id = new Array();
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   for(var i=0;i<all_items.length;i++){
      bcode = all_items[i]['bcode'];
	  if(obj.indexOf(bcode)!=-1){
         subcat = all_items[i]['subcat'];
	     mcat = all_items[i]['mcat'];
	     brnd = all_items[i]['brnd'];
	     store_id[store_id.length]=i;
         if(fil_scat.indexOf(subcat)==-1 && subcat!=''){
		       fil_scat[fil_scat.length]=subcat;
			}
			if(fil_mcat.indexOf(mcat)==-1 && mcat!=''){
		       fil_mcat[fil_mcat.length]=mcat;
			}
			if(fil_brnd.indexOf(brnd)==-1 && brnd!=''){
		       fil_brnd[fil_brnd.length]=brnd;
			}
	  }
   }
   //alert(store_id.length);
   if(store_id.length>0){
	   $('.srchresult_txt').html('Alternative item/s');
	   searchBoxObj.attr('placeholder',obj);
	   create_list(fil_scat, 'sel_scat','');
	   create_list(fil_mcat, 'sel_mcat','');
	   create_list(fil_brnd, 'sel_brnd','');
	   sort_list(store_id);
   }else{

	   $('.srchresult_txt').html('Sorry No alternative item/s found');
	   //init_scan();
	   //$('.srchresult_txt').html('No Items found');
   }
   $('#div_cover1').fadeOut(300);
}
function nonrst_extsearch(bcode){
	//bcode='016229901479';
	//alert(bcode);
	var para = '?_ans='+bcode;
    var url='https://kugans.co/search_filter/connect/barcode_websearch.php';
    url+=para;
	$.ajax({
       url:url,
	   dataType: "jsonp",
	   jsonp: "callback",
	   success: function (a) {
		    //alert(a.message);
		    if(a.message.toString()!='N/A' && a.message!=''){
				//alert('Found items');
				//sort_alt_search(a.message, bcode);
			}else{
				//alert('Barcode search '+bcode);
				//barcode_filtersubstr(bcode);
				//$('.srchresult_txt').html('Sorry No Alternative found');
			}
	   }
   });
}

//barcode_filtersubstr('5021885800122');
function barcode_filtersubstr(bcode){
	//bcode='5011157200508';
	//bcode=encodeURIComponent(bcode);//'5011157200508';
   //alert('Start barcode Scan '+bcode);
   store_id = new Array();
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   var subcat,mcat,brnd,com;
   var l = bcode.length;
   for(var j=2;j<l;j++){
	  var str = bcode.substring(0,j);
	  //console.log(str);
	  for(var i=0;i<all_items.length;i++){
	     com = all_items[i]['bcode'].substring(0,j);
		 subcat = all_items[i]['subcat'];
	        mcat = all_items[i]['mcat'];
	        brnd = all_items[i]['brnd'];	
		 if(com==str && store_id.indexOf(i)==-1 && (fil_scat.indexOf(subcat)!=-1 || fil_scat.length==0)){	
		  //console.log(com+' = '+str+' = '+subcat+' '+fil_scat.indexOf(subcat));	           
	        store_id[store_id.length]=i;
		   if(fil_scat.indexOf(subcat)==-1 && subcat!=''){
		       fil_scat[fil_scat.length]=subcat;
			}
			if(fil_mcat.indexOf(mcat)==-1 && mcat!=''){
		       fil_mcat[fil_mcat.length]=mcat;
			}
			if(fil_brnd.indexOf(brnd)==-1 && brnd!=''){
		       fil_brnd[fil_brnd.length]=brnd;
			}
			if(store_id.length>=50)break;
		 }
      
      }
	  if(store_id.length>=50)break;
   }
   /*for(var i=0;i<all_items.length;i++){
   
   }*/
   //alert(store_id.length);
   if(store_id.length>0){
	   $('.srchresult_txt').html('Similar Brand item/s');
	   searchBoxObj.attr('placeholder',bcode);
	   create_list(fil_scat, 'sel_scat','');
	   create_list(fil_mcat, 'sel_mcat','');
	   create_list(fil_brnd, 'sel_brnd','');
	   sort_list(store_id);
   }else{
	   $('.srchresult_txt').html('No Items found');
	   //init_scan();
	   //$('.srchresult_txt').html('No Items found');
   }
   $('#div_cover1').fadeOut(300);
}
function init_search_rslt(){
	//var stored_rslt = JSON.parse(sessionStorage.getItem("search_rest"));
    const searchJsonStorage=sessionStorage.getItem("search_rest"); 
	var stored_rslt = searchJsonStorage?JSON.parse(LZString.decompress(sessionStorage.getItem("search_rest"))):null;
     //console.log(stored_rslt,"gag");
	if(stored_rslt!=null){
		all_items = new Array();
		all_items=stored_rslt;
        console.log('all_items Length', all_items.length);
		console.log('all_items', all_items);
		$('.spn_total').text('('+all_items.length+')');
		//console.log('Completed '+all_items.length);
	}else{
     
		scnt=0; 
		iniStore = new Array();
	    scanFromDB();
	}
}
function scanFromDB(){
	 var para = '?_ans='+scnt;
        // var url='https://kugans.co/search_filter/connect/get_allrec2a.php';
         //url+=para;
        var url="https://kugans.kugansgroup.com/v1/api/get-all-products"
		$.ajax({
           url:url,
	        // dataType: "jsonp",
	        // jsonp: "callback",
	        success: function (a) {
			   //var obj = JSON.parse(a.message);
              	   var obj = a;
			   for(var i=0;i<obj.length;i++){
				   if(iniStore.indexOf(obj[i])==-1){
				      iniStore[iniStore.length]=obj[i];
				   }
			   }
			   if(obj.length==5000){
				   scnt++;
				   //console.log('More '+iniStore.length+' '+scnt);
				   setTimeout("scanFromDB()",50);
				   //setTimeout("scanFromDB()",1000);
				   return;
			   }else{
				 // console.log('More '+iniStore.length+' '+scnt);
			      all_items = new Array();
	  	          all_items=iniStore;
				  iniStore= new Array();
				  //console.log('More '+all_items.length+' '+scnt);
		          $('.spn_total').text('('+all_items.length+')');
                 ;
                  sessionStorage.setItem("search_rest", LZString.compress(JSON.stringify(all_items)));
			   //   sessionStorage.setItem("search_rest", JSON.stringify(all_items));
			   }
			   //localStorage.setItem("search_rest", JSON.stringify(all_items));
			   //console.log('Completed '+all_items.length);
			}
		});
}
function gather_allrec(){
  //var gather_allrec_var = true;
   if(all_items==null){
	  //console.log('Looping');
	  setTimeout("gather_allrec()",500);
	  return;
   }
   //console.log('Length '+all_items.length);
   $('.cls_itemcont').css('opacity','1');
   if(all_items.length>0){
      $('.cls_serload').hide();
	  init_scan();
	  scn_eble=true;
	  after_scani();
	  $('.cls_coverblk').fadeOut(300);
	  gather_allrec_var = false;
   }
}
var typingTimer;                //timer identifier
var doneTypingInterval = 250;  //time in ms, 5 second for example
//on keydown, clear the countdown 
searchBoxObj.on('keydown', function () {
  //console.log('Clearing Timer');
  clearTimeout(typingTimer);
});

//user is "finished typing," do something
function doneTyping () {
    var str = searchBoxObj.val().toLowerCase();
      if(str == ''){
         $('.srchresult_txt').html('Search results');
      }else{
	    $('.srchresult_txt').html('Search results ('+str+')');
      }
	  after_scani();
	  offer_ini=true;
}
searchBoxObj.keyup(function(e){
   if($('.cls_searchpop').css('display')=='none'){
	   searchBoxObj.click();
   }else{
      clearTimeout(typingTimer);
      //console.log('Reseting');
      typingTimer = setTimeout(doneTyping, doneTypingInterval);
   }
  
});
// searchBoxObj.focusout(function(){
//    if($(this).val()=='')return;
//    var cusid = meta['page']['customerId'];
//    if(cusid=='' || cusid==null)cusid='Unknown';
//      var para = '?_ans='+cusid+'&_ans1='+$(this).val();
//         var url='https://kugans.co/search_filter/connect/search_entrslt.php';
//         url+=para;
// 		$.ajax({
//            url:url,
// 	        dataType: "jsonp",
// 	        jsonp: "callback",
// 	        success: function (a) {
// 			}
// 		});

  
// });
function after_scani(){
	if(!scn_eble){
		$('.cls_itemcont').css('opacity','0.2');
      $('.cls_coverblk').show();
		$('.cls_serload').fadeIn(300);
		//setTimeout("after_scani()",100);
		return;
	}
  var str = searchBoxObj.val().toLowerCase();  
  
  if(str!=''){
	  ini_sta=true;
	  if(str.match(/^[0-9]+$/)==null){
	      setTimeout("scan_items('"+str+"')",100);
	  }else{
		  setTimeout("scan_itemsbcode('"+str+"')",100);
	  }
  }else if(str=='' && ini_sta){
	  ini_sta=false;
	  init_scan();
  }
  update_offer_col();
  update_offer_qty();

}
function scan_itemsbcode(str){
   store_id = new Array();
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   var subcat,mcat,brnd,bcode,com;
   var l = str.length;
   for(var i=0;i<all_items.length;i++){
	  subcat = all_items[i]['subcat'];
	  mcat = all_items[i]['mcat'];
	  brnd = all_items[i]['brnd'];
	  bcode = all_items[i]['bcode'];
	  com = bcode.substring(0,l);
	  if(str==com  && store_id.indexOf(i)==-1 && fil_scat.indexOf(subcat)==-1 && fil_mcat.indexOf(mcat)==-1 && fil_brnd.indexOf(brnd)==-1){
	     store_id[store_id.length]=i;
		 fil_scat[fil_scat.length]=subcat;	
		 fil_mcat[fil_mcat.length]=mcat; 
		 fil_brnd[fil_brnd.length]=brnd;   
	  }
   }
    if(store_id.length>0){
	   create_list(fil_scat, 'sel_scat','');
	   create_list(fil_mcat, 'sel_mcat','');
	   create_list(fil_brnd, 'sel_brnd','');
	   sort_list(store_id);
   }else{
	   $('.srchresult_txt').html('No Items found');
	   //init_scan();
	   //$('.srchresult_txt').html('No Items found');
   }
}
function sort_alt_search(obj, bcode){
   store_id = new Array();
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   var scnitems = new Array();
   if(obj['mgrp']!='unknown'){
      scnitems[0]=obj['mgrp'];
   }else{
      scnitems = obj['keywords'];
   }
   for(var i=0;i<scnitems.length;i++){
      var str = scnitems[i];
	  if(str.length>3 && str!='undefined'){
         str = str.replace(/-/g,' ');
	     var ret = filter_bytxt(str);
		 //alert(ret);
		 if(ret!=''){
		 for(var j=0;j<ret['id'].length;j++){
		    if(store_id.indexOf(ret['id'][j])==-1){
			   store_id[store_id.length]=ret['id'][j];
			}
		    if(fil_scat.indexOf(ret['scat'][j])==-1){
		       fil_scat[fil_scat.length]=ret['scat'][j];
			}
			if(fil_mcat.indexOf(ret['mcat'][j])==-1){
			   fil_mcat[fil_mcat.length]=ret['mcat'][j];
		    }
			if(fil_brnd.indexOf(ret['brnd'][j])==-1){
			   fil_brnd[fil_brnd.length]=ret['brnd'][j];
			}
			if(store_id.length>50)break;
		    }
		  }
		  //alert('In Total '+store_id.length);
		  if(store_id.length>50)break;
		//
	}
	}
	//alert('Total '+store_id.length);
	if(store_id.length>0){
	   //searchBoxObj.keyup();
	   $('.srchresult_txt').html('Close match item/s');
	   searchBoxObj.attr('placeholder',bcode);
	   create_list(fil_scat, 'sel_scat','');
	   create_list(fil_mcat, 'sel_mcat','');
	   create_list(fil_brnd, 'sel_brnd','');
	   sort_list(store_id);
   }else{
	   //$('.srchresult_txt').html('No Items found');
	   barcode_filtersubstr(bcode);
	   return;
	   //init_scan();
	   //$('.srchresult_txt').html('No Items found');
   }
    $('#div_cover1').fadeOut(300);
}
function scan_items(str){
	store_id = new Array();
	fil_scat = new Array();
	fil_mcat = new Array();
	fil_brnd = new Array();
    


	var retval = filter_bytxt(str);
  if(retval!=null){
	store_id=retval['id'];
	fil_scat=retval['scat'];
	fil_mcat=retval['mcat'];
	fil_brnd=retval['brnd'];
  }
   
   if(store_id.length>0){
	   create_list(fil_scat, 'sel_scat','');
	   create_list(fil_mcat, 'sel_mcat','');
	   create_list(fil_brnd, 'sel_brnd','');
	   sort_list(store_id);
	   $('#div_srcwrd').fadeOut(300);
   }else{
	   $('.srchresult_txt').html('No Items found');
	   search_simword(str);
	   //init_scan();
	   //$('.srchresult_txt').html('No Items found');
   }
}
function space_srch(str, src,l){
	for(var i=0;i<str.length;i++){
		str[i]= str[i].replace(/ /g,'');
		com = str[i].toLowerCase().substring(0,l);
		if(com==src){
			//console.clear();
			//console.log(com+'='+str[i]+'='+src);
			return true;
		}
	}
	return false;
}
function filter_bytxt(str){
   var store_id1= new Array();
   var fil_scat1 = new Array();
   var fil_mcat1 = new Array();
   var fil_brnd1 = new Array();
   str = str.toLowerCase();
   str = str.replace(/ /g,'');
   var l = str.length;
   var sep, sep1,sep2,sep3,sep4;
   var inAr=new Array();
   var fil_tag = new Array();var brn_tag = new Array();var scat_tag = new Array();
   var mcat_tag = new Array();var til_tag = new Array();
   var brn,mcat,subcat,sep;

   for(var i=0;i<all_items.length;i++){
	  brn = all_items[i]['brnd'];
	  mcat = all_items[i]['mcat'];
	  subcat = all_items[i]['subcat'];
	  sep = all_items[i]['filcat'].split(',');
	  sep = space_srch(sep,str,l);
	  if(sep){
		  fil_tag[fil_tag.length]=i;	  
	  }
	  inAr[0] = brn;
	  sep = space_srch(inAr,str,l);
	  if(sep){
		  brn_tag[brn_tag.length]=i;	  
	  }
	  inAr[0] = subcat;
	  sep = space_srch(inAr,str,l);
	  if(sep){
		  scat_tag[scat_tag.length]=i;	  
	  }else{
	     sep = subcat.split(' ');
	     sep = space_srch(sep,str,l);
		 if(sep)scat_tag[scat_tag.length]=i;
	  }
	  inAr[0] = mcat;
	  sep = space_srch(inAr,str,l);
	  if(sep){
		  mcat_tag[mcat_tag.length]=i;	  
	  }else{
	     sep = mcat.split(' ');
	     sep = space_srch(sep,str,l);
		 if(sep)mcat_tag[mcat_tag.length]=i;
	  }
     
	  inAr[0] = (all_items[i]['desc'] != undefined && all_items[i]['desc'] != null) ? all_items[i]['desc'].trim() : "";
	  sep = space_srch(inAr,str,l);
	  if(sep){
		  til_tag[til_tag.length]=i;	  
	  }else{
	     sep = (all_items[i]['desc'] != undefined && all_items[i]['desc'] != null) ? all_items[i]['desc'].trim().split(' ') : "";
	     sep = space_srch(sep,str,l);
		 if(sep)til_tag[til_tag.length]=i;
	  }
	  
   }
   var all_tag=[];
   all_tag[0]={'name':mcat_tag,'l':mcat_tag.length}; 
   all_tag[1]={'name':scat_tag,'l':scat_tag.length};
   all_tag[2]={'name':brn_tag,'l':brn_tag.length};
   all_tag[3]={'name':fil_tag,'l':fil_tag.length};
   all_tag[4]={'name':til_tag,'l':til_tag.length};
   for(var i=0;i<all_tag.length;i++){
      if(all_tag[i]['l']>0){
	     for(var key in all_tag[i]['name']){
		    id = all_tag[i]['name'][key];
	        if(store_id1.indexOf(id)==-1){
		       store_id1[store_id1.length]=id;
			   brn = all_items[id]['brnd'];
	           mcat = all_items[id]['mcat'];
	           subcat = all_items[id]['subcat'];
			   if(fil_scat1.indexOf(subcat)==-1 && subcat!=''){
		          fil_scat1[fil_scat1.length]=subcat;
		       }
		       if(fil_brnd1.indexOf(sep)==-1 && sep!=''){
		          fil_brnd1[fil_brnd1.length]=brn;
		       }
		       if(fil_mcat1.indexOf(mcat)==-1 && mcat!=''){
		          fil_mcat1[fil_mcat1.length]=mcat;
		       }			   
			}
	     } 
	  }
   }
   var all_val =[];
   all_val={
      'id' : store_id1,
	  'scat': fil_scat1,
	  'mcat': fil_mcat1,
	  'brnd': fil_brnd1	   
   }
   return all_val;
}
function space_srch_txt(str, txt){
   txt = txt.replace(/ /g,'');
   var src;
      for(var i=0;i<str.length;i++){
	     str[i]= str[i].replace(/ /g,'');
		 com = str[i].toLowerCase();
		 if(com.indexOf(txt)!=-1){			
			return true;
		 }
	  }
	return false;
}
function sortbykey(array, key) {
        return array.sort(function (a, b) {
            var x = b[key]; var y = a[key];
            return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        });
 }
function search_simword(str){
   if(str==''){
      $('#div_srcwrd').fadeOut(300);
	  return;
   }
   var ifexi=new Array();
   var com_tag = new Array();
   var brn,mcat,subcat,ret,sep;
   var inAr = new Array();
   var get_str='';
   var loop=0;
   var l=str.length;
   for(var i=0;i<all_items.length;i++){
      brn = all_items[i]['brnd'];
	  mcat = all_items[i]['mcat'];
	  subcat = all_items[i]['subcat'];
	  title = all_items[i]['desc'].trim();
	  sep = mcat.split(' ');
	   for(var j=0;j<(l-2);j++){
	     ret = space_srch_txt(sep,str.substring(j));
	     if(ret){
			if(ifexi.indexOf(mcat)==-1){
              ifexi[ifexi.length]=mcat;
	           com_tag[com_tag.length]={
			      'name':mcat,
				  'p':j
			   };
	           break;
			}
		 }
	  }
	  sep = brn.split(' ');
	   for(var j=0;j<(l-2);j++){
	     ret = space_srch_txt(sep,str.substring(j));
	     if(ret){
			if(ifexi.indexOf(brn)==-1){
              ifexi[ifexi.length]=brn;
	           com_tag[com_tag.length]={
			      'name':brn,
				  'p':j
			   };
	           break;
			}
		 }
	  }
	  sep = title.trim().replace(brn,'');
	  sep = sep.split(' ');
	   for(var j=0;j<(l-2);j++){
	     var ret = space_srch_txt(sep,str.substring(j));
	     if(ret){
			if(ifexi.indexOf(title)==-1){
              ifexi[ifexi.length]=title;
	           com_tag[com_tag.length]={
				   'name':title,
				   'p':j
			   };
	           break;
			}
		 }
	  }

   } 
   com_tag = sortbykey(com_tag, 'p');
   for(i=0;i<com_tag.length;i++){
	   get_str+='<div><a href="javascript:enter_str(\''+com_tag[i]['name']+'\')">';
	   get_str+=com_tag[i]['name']+'</a></div>';
	   loop++;
	   if(loop>10)break;
   }
   if(get_str!=''){
      var head ='<div>No results found for "<b>'+str+'</b>", showing following results instead</div>';
      $('#div_srcwrd').html(head+get_str);
      $('#div_srcwrd').fadeIn(300);
   }
}
function enter_str(str){
   searchBoxObj.val(str);
   searchBoxObj.keyup();
   $('#div_srcwrd').fadeOut(300);
   
}
function get_allsale(){
	store_id = new Array();
	fil_scat = new Array();
	fil_mcat = new Array();
	fil_brnd = new Array();
	for(var i=0;i<all_items.length;i++){
	   if(all_items[i]['cPri']!='' && all_items[i]['cPri']!=null){
		  store_id[store_id.length]=i;
	   }
	}
	//console.log(store_id.length);
	 if(store_id.length>0){
	   sort_list(store_id);
	   $('.srchresult_txt').html('All sale item/s');
	   $('.subcategory ul li:not(:first-child)').remove();
	   scn_eble=true;
   }else{
	   //$('.srchresult_txt').html('No Items found');
	   init_scan();
	   //$('.srchresult_txt').html('No Items found');
   }
	
}
function filterbysel(){
   //console.log('1');
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   var brf = $('#sel_brnd').val()
   var mcf = $('#sel_mcat').val();
   var saf = $('#sel_scat').val();
   if(saf!='')saf=$( "#sel_scat option:selected" ).text();
   if(mcf!='')mcf=$( "#sel_mcat option:selected" ).text();
   if(brf!='')brf=$( "#sel_brnd option:selected" ).text();
   var sel_items = new Array();
   for(var i=0;i<store_id.length;i++){
      var subcat = all_items[store_id[i]]['subcat'];
	  var mcat = all_items[store_id[i]]['mcat'];
	  var brnd = all_items[store_id[i]]['brnd'];
	  if((saf=='' || saf==subcat) && (mcf=='' || mcf==mcat) && (brf=='' || brf==brnd)){
	     if(fil_scat.indexOf(subcat)==-1 && subcat!=''){
		    fil_scat[fil_scat.length]=subcat;
		 }
		 if(fil_mcat.indexOf(mcat)==-1 && mcat!=''){
	        fil_mcat[fil_mcat.length]=mcat;
	     }
	     if(fil_brnd.indexOf(brnd)==-1 && brnd!=''){
		    fil_brnd[fil_brnd.length]=brnd;
		 }
		  if(sel_items.indexOf(store_id[i])==-1){
		    sel_items[sel_items.length]=store_id[i];
		 }
		  
	  }
	   
   }
   store_id=sel_items;
   //alert(sel_items.length);
   if(sel_items.length>0 && (saf!='' || mcf!='' || brf!='')){
      create_list(fil_scat, 'sel_scat',saf);
	  create_list(fil_mcat, 'sel_mcat',mcf);
	  create_list(fil_brnd, 'sel_brnd',brf);
	  sort_list(sel_items);
   }else{
	   //$('.srchresult_txt').html('No Items found');
	   init_scan();
	   //$('.srchresult_txt').html('No Items found');
   }
}
function sort_list(items, ret, opt, alt) {
    var html = '<div class="see_all_results show-mob"><span class="slresults_arrow">';
    html += 'Total products  </span><span class="spn_total">';
    html += '(' + items.length + ')</span></div><ul class="cls_ulfil">';
    var l = items.length;
    $('.spn_total').text('(' + l + ')');

    var uniqueProducts = {};
    var uniqueItems = [];

    for (var i = 0; i < l; i++) {
        var proid = all_items[items[i]]['proid'];
        if (!uniqueProducts[proid]) {
            uniqueProducts[proid] = true;
            uniqueItems.push(items[i]);
        }
    }

    l = uniqueItems.length > 24 ? 24 : uniqueItems.length;

    for (var i = 0; i < l; i++) {
        var d = new Array();
        var itemIndex = uniqueItems[i];
        d[0] = capitalise(all_items[itemIndex]['desc']);
        d[1] = all_items[itemIndex]['proid'];
        d[2] = all_items[itemIndex]['limit'];
        d[3] = all_items[itemIndex]['ven'];
        d[4] = all_items[itemIndex]['pri'];
        d[5] = all_items[itemIndex]['packsz'];
        d[6] = all_items[itemIndex]['qty'];
        d[7] = all_items[itemIndex]['brnd'];
        d[8] = all_items[itemIndex]['hdle'];
        d[9] = all_items[itemIndex]['cPri'];
        d[10] = all_items[itemIndex]['bcode'];
        if (opt) {
            d[11] = '';
        } else {
            d[11] = all_items[itemIndex]['grpn'];
        }
        d[12] = all_items[itemIndex]['offerid'];
        html += '<li id="lifilter_' + d[1] + '" data-id="' + d[12] + '">';
        html += getEachItem(d, itemIndex, alt); // gen_list(d);
        html += '</li>';
    }
    html += '</ul>';
    if (ret) {
        if (l == 0) html = '';
        return html;
    } else {
        $('.cls_itemcont').html(html);
    }
}
function capitalise(str){
	str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
    return letter.toUpperCase();
    });
  return str;
}
function gen_list(d){
   var html='';
   html+='<div class="cls_ulin"><ul>';
   html+='<li><img src="https://cdn.shopify.com/s/files/1/0270/7157/8246/products/'+d[1]+'_0.jpg" ';
   html+='width="50px" /></li><li>'+d[0]+'</li>';
   html+='<li><button class="btn" type="button">Add to Cart</button></li></ul></div>';
   return html;
}
var cnt;
function init1(){
  var initvar = true;
  if(initvar){
   //all_items = new Array();
   cnt=0;
   //gather_allrec();
   styling();
   $('.quickSearchResultsWrap').hide();
   best_sellers();
  }
}

function best_sellers(){
   /*if(typeof offerCt === 'undefined'){
	   setTimeout("best_sellers()",500);
	   return;
   }*/
	//l_item = [];
	if(searchBoxObj.val()=='')$('.srchresult_txt').text('Best Sellers');
	var html='<div class="see_all_results show-mob"><span class="slresults_arrow">';
	html+='Total Products  </span><span class="spn_total">('+best_sel.length+')';
	html+='</span></div><ul class="cls_ulfil">';
    //$('.spn_total').text('('+all_items.length+')');
	//console.log('Best sel '+offerCt);
  $('.spn_total.initbestseltotal').text('('+best_sel.length+')');
	for(var i=0;i<best_sel.length;i++){
	   var d = new Array();;
	  d[0]=capitalise(best_sel[i]['desc']);
	   d[1]=best_sel[i]['proid'];
	   d[2]=best_sel[i]['limit'];
	   d[3]=best_sel[i]['ven'];
	   d[4]=best_sel[i]['pri']/100;
	   d[5]=best_sel[i]['packsz'];
	   d[6]=best_sel[i]['qty'];
	   d[7]=best_sel[i]['brnd'];
	   d[8]=best_sel[i]['hdle'];
	   d[9]=best_sel[i]['cPrice']/100;
	   d[10]='';
	   d[11]=best_sel[i]['grpn'];
	   d[12]=best_sel[i]['offerid'];
	   html+='<li id="lifilter_'+d[1]+'" data-id="'+d[12]+'">';
	   //console.log('Best seller loop '+d+' = '+i);
	   html+=getEachItem(d,i);//gen_list(d);
	   html+='</li>';
	}
	html+='</ul>';
	$('.cls_itemcont').html(html);
	create_list(ini_tags, 'sel_scat','');
}
function init_scan(){
   store_id = new Array();
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   //l_item = [];
   for(i=0;i<all_items.length;i++){
      var subcat = all_items[i]['subcat'];
	  var mcat = all_items[i]['mcat'];
	  var brnd = all_items[i]['brnd'];
	  store_id[i]=i;
	  if(fil_scat.indexOf(subcat)==-1 && subcat!=''){
	    //fil_scat[fil_scat.length]=subcat; 
	  }
	  if(fil_mcat.indexOf(mcat)==-1 && mcat!=''){
	     fil_mcat[fil_mcat.length]=mcat; 
	  }
	  if(fil_brnd.indexOf(brnd)==-1 && brnd!=''){
	     fil_brnd[fil_brnd.length]=brnd; 
	  }
	  l_item[all_items[i]['proid']]=all_items[i]['limit'];
   }
   //fil_scat= ini_tags;
   var saf=$( "#sel_scat option:selected" ).text();
   var mcf=$( "#sel_mcat option:selected" ).text();
   var brf=$( "#sel_brnd option:selected" ).text();
   //create_list(fil_scat, 'sel_scat',saf);
   create_list(fil_mcat, 'sel_mcat',mcf);
   create_list(fil_brnd, 'sel_brnd',brf);
   sort_list(store_id);
   $('.spn_total').text('(' +  all_items.length + ')');
   best_sellers();
}
function create_list(data, id, inSel){
	var list_ary=[];
	if(id != 'sel_scat')data.sort();
	list_ary['sel_scat']='Sub Category';
	list_ary['sel_mcat']='Category';
	list_ary['sel_brnd']='Brand';
	html='';
  	var listHtml = '';
	for(i=0;i<data.length;i++){
		//console.log(data[i]);
		if(data[i]!='' && data[i]!=null){
		   var sel='';
          	var selectClass = '';
		   if(inSel==data[i]){
			   sel='selected';
             selectClass = 'active';
		   }
		   var val = data[i].toLowerCase().replace(/ /g,'-');
		   html+='<option value="'+i+'" '+sel+'>'+data[i]+'</option>';
          listHtml+='<li><a class="'+selectClass+'" href="javascript:;" data-val="'+i+'" data-txt='+val+'>';
		  listHtml+=data[i]+'</a></li>';
		}else{
			//console.log('Null '+id);
		}
	}
	var txt = list_ary[id]+' ('+data.length+')';
	$('#'+id).find('option').eq(0).text(txt);
	$('#'+id).find('option').not(':first').remove();
	$('#'+id).append(html);
  
    if(id == 'sel_scat'){
		$('.subcategory  ul').html(listHtml);
		$('[data-txt="sale"]').css({
		   'background-color' :'red',
		   'color':'#fff'
		});
    }
  
}
//var satpoint=900;
$(document).ready(function(){
   $('.cls_searchpop').scroll(function(){
      if($('.cls_searchpop').css('display')!='none' && scn_eble){
	     var txt =$('.srchresult_txt').text();
	     var th= $(this).scrollTop() + $(this).innerHeight();
	     var ch = $(this)[0].scrollHeight - 1000;
	     if(th >= ch && txt.toLowerCase()!='best sellers') {
            var str = $('.cls_ulfil li').length;
	        var end = str+12;
		    var l = store_id.length;
		    if(end>l)end=l;
		    if(str<l)all_lines(str,end);
         }
     }
   });
});
function styling(){
   var obj = $('.cls_searchpop');
   insert_html(obj);
   var obj1 = $('.header-search:eq(1)');
   var height = $('.wrapper-header').height();
   var newHeight = $('.site-header').height() + 40;
   var w = obj1.width();
   var h = obj1.height();
   var offset = obj1.offset();
   h=h+offset.top-4;
  if($(window).width() > 1199){
   obj.css({
      'position' : 'fixed',
	  'width' : '100%',
	  'max-height' : '76vh',
	  'background-color':'#fff',
/*	  'border':'1px solid #eee',*/
	  'border-top':'none',
	 // 'border-radius':'5px 0px 0px 5px',
// 	  'top':h+'px',
      'top':newHeight+'px',
	  //'left':offset.left+'px',

	  'left':'0px',
	  'text-align' : 'center',
	  'overflow' :'auto'	  
   });
  }else{
   obj.css({
      'position' : 'fixed',
	  'width' : '100%',
	  'max-height' : '81vh',
	  'background-color':'#fff',
	  'border-top':'none',
      'top':newHeight+'px',
	  'left':'0px',
	  'text-align' : 'center',
	  'overflow' :'auto'	  
   });
  }
   $('.cls_searchpop div').css({
	  'margin':'auto',
	  'padding':'5px',
	  'border-bottom':'1px solid #eee'
   
   });
   $('.cls_filul').css({
      'list-style-type': 'none',
      'margin':'0',
      'padding': '0',
      'overflow': 'hidden'
   });
   $('.cls_filul li').css({
	   'float':'left',
	   'display':'inline',
	   'padding-right':'20px',
   });
   $('.cls_filul li select').css({
	   'width':'160px',
	   'border':'none'
   });
   $('.cls_serload').css({
       'position':'absolute',
	   'margin-left' :'45%',
	   'margin-top' :'10%',
	   'z-index':1000001,
	   'display':'none'
   });
   $('.cls_coverblk').css({
    'position':'absolute',
    'width':'100%',
    'height':'130px',
    'opacity':'0.8',
	'background-color':'#fff',
    'background-image': 'url(https://cdn.shopify.com/s/files/1/0270/7157/8246/files/ajax-loader.gif)',
    'background-repeat': 'no-repeat',
    'background-position': 'center',
	'background-size': 'auto 50%',
     'display':'none',
	'z-index':1000002,
    
  });
    obj.fadeIn(600);
	obj = $('.nav-search');
	 $('#div_srcwrd').css({
	  'position':'absolute',
      'width': obj.width()+'px',
	  'height':'200px',
	  'border':'1px solid #eee',
	  'padding':'5px',
	  'background-color':'#fff',
	  'z-index':1000,
	  'overflow':'auto'
	  
   });
   $('#div_srcwrd div').css('padding-bottom','5px');
}
function fetchProductData(d, id, srch) {
  return $.getJSON('/products/' + d[8] + '.js')
    .done(function(product) {
        return renderEachItem(d, id, srch);
    })
    .fail(function(jqxhr, textStatus, error) {
        console.error('Request Failed: ', textStatus, ', ', error);
        return "";
    });
}
function getEachItem(d, id, srch){
  return renderEachItem(d, id, srch);
}
function renderEachItem(d, id, srch){
  var src = 'https://cdn.shopify.com/s/files/1/';
   src+='0270/7157/8246/products/'+d[1]+'_0.jpg';
   //var pri = parseFloat(d[4]).toFixed(2);
   var sbdge='';
   getQty = 0;
   //console.log('Group nam '+d[11]);
  var pri = parseFloat(d[4]).toFixed(2);
   if(d[9]!='0' && d[9]!='' && d[9]!=null && d[9]!='0.00'){
	   var comp = parseFloat(d[9]);
	   //comp = comp;
	   var str='<span class="cls_cpri">';
	   str+=''+comp.toFixed(2)+'</span><span class="cls_sale" ';
	   str+='itemprop="price">£'+pri+'</span>';
	   var per =(comp/pri)-1 ;
	   per=per*100;
	   per = parseInt(per);
	   sbdge='<div class="cls_sbadge">'+per+'%<br/>OFF</div>';
	   pri=str;
   }
   if(errimg['simg_'+d[1]]!=null){
	   src=errimg['simg_'+d[1]];
   }
   noex_item_stock[d[1]]=d[6];
   var lnk = d[8];
  //console.log('ddddd',d);
  //console.log('d[2]',d[2]);
  let vendorlink = d[7].toLowerCase().trim().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-');
  
  let productLink = `/products/${lnk}`;
  //Removed variant id from link as d[2] is not passing shopify variant id
    // if (d[2] !== null && d[2] !== undefined) {
    //   productLink += `?variant=${d[2]}`;
    // }
   var html='<div class="cls_libody cls_find">'+sbdge;   
   html+='<div class="cls_itimg">';
   html+='<a href="/products/'+lnk+'" class="product-grid-image">';
   html+='<img alt="'+d[0]+'" src="'+src+'" id="simg_'+d[1]+'" onerror="imgErro(this)"></a></div>';
   html+='<div class="cls_stsmsg">'

    // Commenting this code because now we do not have offerCt because we commented https://kugans.co/offer/get_offer.php endpoint
   /*if(d[12]!='' && offerCt[d[12]]!=null){
	 if(ex_items[d[1]]!=null){
          getQty+=parseInt(ex_items[d[1]]);
        }   
	 html+='<a href="javascript:display_offer(\''+d[12]+'\');">'
     html+='<div align="center" style="height:20px;font-size:12px; font-weight: 600; color:#e1a53d" data-id="'+ d[12]+'" class="cls_offerct cls_offerct-'+ d[1]+'">';
     var msg = '';//calOfferMsg_com(getQty,offerCt[d[12]]['trPoint'],d[12],'','1');
	 html+='<span class="cls_offmsg clsoffer_'+d[12]+'"></span>';
     html+='</div></a>';
     html+= '<input type="hidden" value="'+d[12]+'" class="cls_offer" id="fldoffer_'+d[1]+'" />';
   }*/

  
   html+='</div><div style="height:100px"><div class="product-bottom">';
   html+='<div class="product-vendor"><a href="/collections/'+vendorlink+'" ';
   html+='title="'+d[7]+'">'+d[7]+'</a></div><a class="product-title" ';
   html+=`href="${productLink}">`;
   html+='<span>'+d[0]+'</span></a><div class="cls_warmess cls_mod" data-warm-'+d[1]+'="" ';
   html+='style="display:none"></div><div class="price-box"><div class="price-regular">';
   html+='<div class="cls_pcksz" style="font-weight:normal">'+d[5]+'</div>';
   html+='<span>£'+pri+'</span>';
   html+='<div style="font-weight:normal;color:#999">'+cal_per_fil(d[5],d[4]*100)+'</div>';
   html+='</div></div></div></div>';  
   var sty;
   var sty1;
   var sel_opt='';
   if(d[11]!=''){
	   sty1='style="display:none"';
	   sty='style="display:none"';
	   sel_opt+='<button id="findalt_'+d[1]+'" class="btn" ';
       sel_opt+='style="background-color:#952882;color:#fff" ';
       sel_opt+='type="button" onclick="fnd_opt(\''+d[11]+'\')">';
	   sel_opt+='Select Option</button>'; 
   }else if(ex_items[d[1]]==null || ex_items[d[1]]==0){
	   sty='';
	   sty1='style="display:none"';
   }else{
	   sty1='';
	   sty='style="display:none"'; 
   }
   l_item[d[1]]=d[2];
   if(erradditems.indexOf(d[10])==-1 && d[6]>0){
      html+='<div class="qty-collection cls_sermul qty-input-wrapper" data-qtyinputwrapper-id="'+d[1]+'" id="divser_mul_'+d[1]+'" ';
      html+=sty1+'><a id="serbtnrem_'+d[1]+'" class="minus button ser-plmin minus-btn-selector" data-minusbtnselector-id="'+d[1]+'"></a>';
      html+='<input type="text" id="serfld_'+d[1]+'" value="'+ex_items[d[1]]+'" disabled="" ';
      html+='class="cls_serfld qty-input-selector" data-qtyinputselector-id="'+d[1]+'"><a id="serbtnadd_'+d[1]+'" ';
      html+='class="plus button ser-plmin plus-btn-selector" data-plusbtnselector-id="'+d[1]+'"></a></div>';  
      html+='<div class="cls_btmmess" data-btmmess-'+d[1]+'=""></div>';
      html+='<div class="action cls_new add-btn-wrapper" data-addbtnwrapper-id="'+d[1]+'" id="divser_new_'+d[1]+'" '+sty+' ';
      html+='data-addnew-'+d[2]+'="">';
      html+='<button id="seritem_'+d[1]+'" class="btn cls_srchaddtocart add-btn-selector" data-addbtnselector-id="'+d[1]+'"';
      html+='type="button">';
      html+='Add to Cart</button></div>';
   }else if(d[6]<1){
	  html+='<div class="cls_btmmess"></div><button id="findalt_'+d[1]+'" class="btn" ';
      html+='style="background-color:#fd7e14;color:#fff" ';
      html+='type="button" onclick="filter_alt(\''+id+'\')">';
	  html+='Find Alternative</button>';	   	  
   }else{
	   html+='<div style="color:red">Sorry, this item is no longer available!</div>';
   }
   html+=sel_opt;
   html+='<div class="mobile-top-compare-align">';
   html+='<a class="wishlist" data-icon-wishlist href="#" data-product-handle="'+lnk+'" data-id="'+d[1]+'">';
   html+='<img src="//cdn.shopify.com/s/files/1/0270/7157/8246/t/29/assets/icon-wishlist.png?v=13270250606194248218" alt="Favorite Icon" style="width: 20px;margin-top: 2px;" />';
   html+='</a><div class="compare-section-wrapper" id="compare_'+d[1]+'">';
   html+='<div class="custom-compare">';
   html+='<input type="checkbox" class="compare-chkbox" name="compare_chkbox" id="compare_chkbox_'+d[1]+'" data-product-id="'+d[1]+'" value="'+lnk+'" >';
   html+='<label style="line-height: 30px;" id="compare" class="compare" for="compare_chkbox_'+d[1]+'">';
   html+='<img src="//cdn.shopify.com/s/files/1/0270/7157/8246/t/29/assets/icon-compare.png?v=5365063039897137369" alt="Compare Icon" style="width: 20px;">';
   html+='</label></div></div>';
   if(!srch){
      html+='<div class="cls_smi-item" id="btnalt_'+d[1]+'">';
      html+='<svg aria-hidden="true" focusable="false" data-prefix="far" ';
      html+='data-icon="fire" role="img" xmlns="http://www.w3.org/2000/svg" ';
      html+='viewBox="0 0 384 512" class="svg-inline--fa fa-fire fa-w-12 ';
      html+='fa-2x"><path fill="currentColor" d="M216 24.01c0-23.8-31.16-33.';
      html+='11-44.15-13.04C76.55 158.25 200 238.73 200 288c0 22.06-17.94 40-40 ';
      html+='40s-40-17.94-40-40V182.13c0-19.39-21.86-30.76-37.73-19.68C30.75 ';
      html+='198.38 0 257.28 0 320c0 105.87 86.13 192 192 192s192-86.13 ';
      html+='192-192c0-170.29-168-192.85-168-295.99zM192 464c-79.4 0-144-64.6-144-144 ';
      html+='0-28.66 8.56-64.71 24-88v56c0 48.52 39.48 88 88 88s88-39.48 ';
      html+='88-88c0-64.27-88-120-64-208 40 88 152 121.77 152 240 0 ';
      html+='79.4-64.6 144-144 144z" class=""></path></svg>';
      html+='Find Similar Items</div>';
   }
   html+='</div>';

    // Commenting this code because now we do not have offerCt because we commented https://kugans.co/offer/get_offer.php endpoint
    /*if(d[12]!=''){
	  if(all_offer_exi[d[12]]!=null){ 
         html+='<a href="javascript:display_offer(\''+d[12]+'\');">';
		 html+='<div class="upsell-button"><span>'+all_offer_exi[d[12]];
		 html+='</span></div></a>';
	  }
   }*/
   html+='</div>';
   html+='</div>';
	return html;
   halo.updateProductCardUI();
}
function cal_per_fil(d, p){
  return '';
  var un = d.replace(/[0-9]/g, '');
  un = un.replace('.','');
  var val = d.replace(un,'');
  if(val=='' || val==null)return '';
  var cal = p/val;
  switch(un.toLowerCase()){
    case 'kg':cal = cal/100;break;
    case 'pcs':cal = cal/100;un='pc';break;
    case 'g':un='100g';break;
    case 'ml':un='100ml';break;
    case 'ltr':cal = cal/100;break;
  }
  
  cal = toFixed_fil(cal,2);
  if(cal.length<4)cal+='0';
  var str = '(£'+cal+'/'+un+')';
  return str;
}
function toFixed_fil(num, fixed) {
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return num.toString().match(re)[0];
}
function fnd_opt(grpn){
   $('#div_cover1').fadeIn(300,function(){
      $('html, body').animate({scrollTop:0}, 'slow', function(){
		   scngrpn_loop(grpn);
	  });
   });	
}
function scngrpn_loop(id){
   store_id = new Array();
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   for(var i=0;i<all_items.length;i++){
      if(id==all_items[i]['grpn']){
	     subcat = all_items[i]['subcat'];
	     mcat = all_items[i]['mcat'];
	     brnd = all_items[i]['brnd'];
	     store_id[store_id.length]=i;
         if(fil_scat.indexOf(subcat)==-1 && subcat!=''){
		    fil_scat[fil_scat.length]=subcat;
		 }
		 if(fil_mcat.indexOf(mcat)==-1 && mcat!=''){
		    fil_mcat[fil_mcat.length]=mcat;
		 }
		 if(fil_brnd.indexOf(brnd)==-1 && brnd!=''){
		    fil_brnd[fil_brnd.length]=brnd;
		 }
      }
   }
   var html;
   if(store_id.length>0){
	   html = 'Alternative item/s found';
	   $('.srchresult_txt').html(html);
	   create_list(fil_scat, 'sel_scat','');
	   create_list(fil_mcat, 'sel_mcat','');
	   create_list(fil_brnd, 'sel_brnd','');
	   sort_list(store_id,false,true,true);
   }else{
	   html='<span style="color:#fd7e14;font-weight: bold;">';
	   html+='Sorry no Alternative Item found';
	   html+='</span>';
	   $('.srchresult_txt').html(html);
   }
   $('#div_cover1').fadeOut(300);
}
function filter_alt(id){
   $('#div_cover1').fadeIn(300,function(){
      $('html, body').animate({scrollTop:0}, 'slow', function(){
		   alt_item_loop(all_items[id]['filcat'].split(','),false,id);
	  });
   });
}
function alt_item_loop(sep, ret,index){
	//alert('ID '+id);
  //console.log(sep,ret,index);
	store_id = new Array();
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   var subcat,mcat,brnd,sep1;
   //var sep = all_items[id]['filcat'].split(',');
   //alert(sep);
   for(var j=0;j<sep.length;j++){
      for(var i=0;i<all_items.length;i++){
	     if(i!=index){
            sep1 = all_items[i]['filcat'].split(',');
           if(all_items[1].barcode=='3574661440477'){
          //  console.log(sep1,"test",sep[j],all_items[i],sep1.indexOf(sep[j]));
           }
	        if(sep1.indexOf(sep[j])!=-1 && all_items[i]['qty']>0){
		 
               subcat = all_items[i]['subcat'];
	           mcat = all_items[i]['mcat'];
	           brnd = all_items[i]['brnd'];
	           store_id[store_id.length]=i;
               if(fil_scat.indexOf(subcat)==-1 && subcat!=''){
		          fil_scat[fil_scat.length]=subcat;
			   }
			   if(fil_mcat.indexOf(mcat)==-1 && mcat!=''){
		          fil_mcat[fil_mcat.length]=mcat;
			   }
			   if(fil_brnd.indexOf(brnd)==-1 && brnd!=''){
		          fil_brnd[fil_brnd.length]=brnd;
			   }
	        }
		 }
      }
   }
   if(ret){
      return store_id;
   }
   var html;
   //console.log('Nof items '+store_id.length);
   if(store_id.length>0){
	   html = 'Alternative item/s found';
	   $('.srchresult_txt').html(html);
	   create_list(fil_scat, 'sel_scat','');
	   create_list(fil_mcat, 'sel_mcat','');
	   create_list(fil_brnd, 'sel_brnd','');
	   sort_list(store_id);
   }else{
	   html='<span style="color:#fd7e14;font-weight: bold;">';
	   html+='Sorry no Alternative Item found';
	   html+='</span>';
	   $('.srchresult_txt').html(html);
   }
   $('#div_cover1').fadeOut(300);
}
/*function alt_item_loop(id){
	store_id = new Array();
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   var subcat,mcat,brnd,sep1;
   var sep = all_items[id]['filcat'].split(',');
   for(var j=0;j<sep.length;j++){
      for(var i=0;i<all_items.length;i++){
         sep1 = all_items[i]['filcat'].split(',');
	     if(sep1.indexOf(sep[j])!=-1 && all_items[i]['qty']>0){
			//console.log(sep1+' '+sep[j]);
            subcat = all_items[i]['subcat'];
	        mcat = all_items[i]['mcat'];
	        brnd = all_items[i]['brnd'];
	        store_id[store_id.length]=i;
            if(fil_scat.indexOf(subcat)==-1 && subcat!=''){
		       fil_scat[fil_scat.length]=subcat;
			}
			if(fil_mcat.indexOf(mcat)==-1 && mcat!=''){
		       fil_mcat[fil_mcat.length]=mcat;
			}
			if(fil_brnd.indexOf(brnd)==-1 && brnd!=''){
		       fil_brnd[fil_brnd.length]=brnd;
			}
	     }
      }
   }
   var html;
   if(store_id.length>0){
	   html = 'Alternative item/s found';
	   $('.srchresult_txt').html(html);
	   create_list(fil_scat, 'sel_scat','');
	   create_list(fil_mcat, 'sel_mcat','');
	   create_list(fil_brnd, 'sel_brnd','');
	   sort_list(store_id);
   }else{
	   html='<span style="color:#fd7e14;font-weight: bold;">';
	   html+='Sorry no Alternative Item found';
	   html+='</span>';
	   $('.srchresult_txt').html(html);
   }
   $('#div_cover1').fadeOut(300);
}
*/
function all_lines(str,end){

   var html='';
	for(var i=str;i<end;i++){
	   var d = new Array();;
	   d[0]=capitalise(all_items[store_id[i]]['desc']);
	   d[1]=all_items[store_id[i]]['proid'];
	   d[2]=all_items[store_id[i]]['limit'];
	   d[3]=all_items[store_id[i]]['ven'];
	   d[4]=all_items[store_id[i]]['pri'];
	   d[5]=all_items[store_id[i]]['packsz'];
	   d[6]=all_items[store_id[i]]['qty'];
	   d[7]=all_items[store_id[i]]['brnd'];
	   d[8]=all_items[store_id[i]]['hdle'];
	   d[9]=all_items[store_id[i]]['cPri'];
	   d[10]=all_items[store_id[i]]['bcode'];
	   d[11]=all_items[store_id[i]]['grpn'];
	   d[12]=all_items[store_id[i]]['offerid'];
	   html+='<li id="lifilter_'+d[1]+'" data-id="'+d[12]+'">';
	   html+=getEachItem(d, store_id[i]);
	   html+='</li>';
	}
	$('.cls_ulfil').append(html);
	update_offer_qty();
	//console.log('Update Offer QTY');
	//alert('Update offer');
	//update_offer_qty();
}
function insert_html(obj){
   //alert('Initiate');
   var html='<div class="cls_serload">';
   html+='<!--<img src="https://cdn.shopify.com/s/files/1/';
   html+='0270/7157/8246/files/ajax-loader.gif?v=1586006132" ';
   html+='width="100px">--></div>';
   html+='<div class="cls_filhead" align="left">';
   html+='<ul class="cls_filul">';
   html+='<li class="see_all_results_mob hide-mob">';
   html+='<div class="see_all_results"><span class="slresults_arrow">';
   html+='Total Products  </span><span class="spn_total"></span></div></li>';
   html+='<li class="brand"><span class="brand_arrow">';
   html+='<img src="https://cdn.shopify.com/s/files/1/0270/7157/8246/files/';
   html+='Angle_down.png"></span>'+get_each_list('Brand','sel_brnd')+'</li>';
   html+='<li class="category"><span class="category_arrow">';
   html+='<img src="https://cdn.shopify.com/s/files/1/0270/7157/8246/files/';
   html+='Angle_down.png"></span>'+get_each_list('Category','sel_mcat')+'</li>';
   html+='<li id="subcategory_wrapper"><span class="subcategory_arrow">';
   html+='<img src="https://cdn.shopify.com/s/files/1/0270/7157/8246/files/';
   html+='Angle_down.png"></span>'+get_each_list('Sub Category','sel_scat')+'</li>';
   html+='<li class="clearfilter">Clear filters</li>';
   html+='</ul><div class="srchresult_txt">Search results</div>';
   html+='<ul class="cls_filulright">';
   html+='<li><div class="see_all_results"><span class="slresults_arrow">';
   html+='Total Products  </span><span class="spn_total initbestseltotal"></span></div></li>';
   html+='<li class="close"><span><img src="https://cdn.shopify.com/s/files/1/0270';
   html+='/7157/8246/files/close_icon_f54f09b6-85b1-40c9-a528-6fdef32d352e.jpg">';
   html+='Close</span></li></ul>';
   html+='</div>';
   html+='<div class="subcategory"><div class="cls_coverblk"></div><ul>';
   /*for(var i=0;i<ini_tags.length;i++){
	   html+='<li><a href="#">'+ini_tags[i]+'</a></li>';
   }*/
   html+='<li style="width:100%; text-align="center"">Loading please wait....</li>';
   html+='</ul></div>';
   html+='<div class="cls_itemcont"><div>';
   obj.html(html);
   	
}
function get_each_list(head, id){
   var html='<select id="'+id+'" onchange="filterbysel()">';
   html+='<option value="">'+head+'</option>';
   html+='</select>';
   return html;
}
function imgErro(obj){  
   if(errimg[obj.id]==null){ 
      var id = obj.id.split('_');
	  var varid = $('#lifilter_'+id[1]+' .product-grid-image').attr('href');
	  if(varid!=null){
	     varid = varid.split('/');
	     varid= varid[varid.length-1];
	     $.getJSON('/products/'+varid+'.js', function(product) {
			errimg[obj.id]=product.featured_image;
		    $('#'+obj.id).attr('src',product.featured_image);
	     });
	  }
   }
}

function initiate_addtocart(id, pid){
	//alert(id+' '+pid);
	Shopify.addItem(id,1, function (cart) {
        $('#serfld_'+pid).val('1');
         $('#divser_new_'+pid).hide();
         $('#divser_mul_'+pid).fadeIn(300);
      
      	$('#fld_'+pid).val(1);
      	$('#div_new_'+pid).hide();
      	$('#div_mul_'+pid).fadeIn(300);
		 var str ='<span style="color:green; font-size:10px">';
         str+='Added to basket</span>'
		 $('#lifilter_'+pid+' .cls_btmmess').html(str);
         //halo._captureProductMetaInfo('search_offer', pid, true, cart); // for search dropdown
         //halo._captureProductMetaInfo('alt_offer', pid, true, cart); // for alternative popup
		 sel_offer = $('#lifilter_'+pid).attr('data-id');
		 //alert(sel_offer);
         ex_items[pid]=1;
		 proid_varid[id]=pid;
		 if(typeof proid_varid1 != 'undefined')proid_varid1[id]=pid;
		 if(sel_offer!=''){
            offer_items[pid]={
               'offerid': sel_offer,
               'qty' : 1,
		       'vid' :id
             };
         }
		 //alert(ex_items[id]+' '+id);
		 halo.updateDropdownCart();
      
      });
}
function subcat_looping(val){
  //console.log('Looping'+val);
	if(!all_items || $('.cls_coverblk').css('display')!='none'){
		setTimeout(function() {
          subcat_looping(val);
       }, 300);
	   return;
	}
	$('[data-val="'+val+'"]').click();
	   //[data-val=\"0\"]'
}
$(document).on('click','.subcategory ul li a',function(){
  var dataVal  = $(this).attr('data-val');
	if(!all_items){
		$('.cls_itemcont').css('opacity','0.2');
		$('.cls_coverblk').show();
		$('.cls_serload').fadeIn(300);
	   setTimeout(function() {
          subcat_looping(dataVal);
       }, 300);
	   return;
	}
	var dataTex= $(this).attr('data-txt');
	if(dataVal=='0' && $('.srchresult_txt').text()=='All sale item/s'){
		init_scan();
		return;
	}
	$('.srchresult_txt').text('');
  	$("#sel_scat option").removeAttr('selected');
    if($(this).hasClass('active')){
      //$("#sel_scat option[value='']").attr('selected', 'selected');
	  $("#sel_scat").val('');
      $('.cls_filhead .cls_filul li.clearfilter').css('color','#000');
	  store_id = new Array();
	  if(searchBoxObj.val()==''){
		 init_scan();
        $('#sel_mcat').change();
	  }else{
		scan_items(searchBoxObj.val());
  	    //$("#sel_scat").change();
	  }
    }else{
	   switch(dataTex){
		   case 'fresh-vegetables' : 
		      $('#sel_mcat').val(7);
		      $('#sel_mcat').change();
		   break;
		   case 'fresh-fruits' : 
		      $('#sel_mcat').val(10);
		      $('#sel_mcat').change();
		   break;


		   case 'fruits-unit' : 
		      $('#sel_mcat').val(9);
		      $('#sel_mcat').change();
		   break;
		    case 'sale' : 
		      get_allsale();
		   break;
		   default:
		      $("#sel_scat").val(dataVal);
              $('.cls_filhead .cls_filul li.clearfilter').css('color','#ff7a03');
	          $("#sel_scat").change();
	   }
	}
	
});

$(document).on('click','.clearfilter',function(){
	searchBoxObj.val('').keyup();
  
    var dataVal  = $('.subcategory ul li a').attr('data-val');
    $("#sel_scat option").removeAttr('selected');
    if($('.subcategory ul li a').hasClass('active')){
      $("#sel_scat option[value='']").attr('selected', 'selected');
      $('.cls_filhead .cls_filul li.clearfilter').css('color','#000');
    }
    //$("#sel_scat").change();
	$('#sel_mcat, #sel_brnd').val('');
	init_scan();
});



$(document).on('click','.cls_srchaddtocart',function(){
	//alert('.cls_srchaddtocart');
	var id = $(this).attr('id').split('_');
	var varid = $('#lifilter_'+id[1]+' .product-grid-image').attr('href');
	varid = varid.split('/');
	varid= varid[varid.length-1];
	var html,index;
	$.getJSON('/products/'+varid+'.js', function(product) {
		  html ='<img src="https://cdn.shopify.com/s/files/1/0270/7157/8246/';
		  html+='files/loader2.gif?v=1597584876" style="height:18px">';
		  $('#seritem_'+id[1]).html(html);
		  if(!product.available){
             html='<span style="color:red">Sorry, this item is no longer available!</span>'; 
			 $('#divser_new_'+id[1]).html(html);
			 var index = get_index(id[1]);
			 all_items[index]['qty']=0;
		  }else{
			 initiate_addtocart(product.variants[0]['id'], id[1]); 
		  }
    }).fail(function() {
	   html='<span style="color:red">Sorry, this item is no longer available!</span>'; 
	   $('#divser_new_'+id[1]).html(html);
	   index = get_index(id[1]);
	   all_items[index]['qty']=0;
	});
	
});
function barcode_erraddtocart(bcode){
   store_id = new Array();
   fil_scat = new Array();
   fil_mcat = new Array();
   fil_brnd = new Array();
   var subcat,mcat,brnd,com;
   var l = bcode.length;
  for(var j=1;j<l;j++){
	  var str = bcode.slice(0,-(j));
	  //console.log(str);
	  for(var i=0;i<all_items.length;i++){
	     com = all_items[i]['bcode'].slice(0,-(j));
		 subcat = all_items[i]['subcat'];
	        mcat = all_items[i]['mcat'];
	        brnd = all_items[i]['brnd'];	
		 if(com==str && store_id.indexOf(i)==-1 && (fil_scat.indexOf(subcat)!=-1 || fil_scat.length==0)){	
		  //console.log(com+' = '+str+' = '+subcat+' '+fil_scat.indexOf(subcat));	           
	        store_id[store_id.length]=i;
		   if(fil_scat.indexOf(subcat)==-1 && subcat!=''){
		       fil_scat[fil_scat.length]=subcat;
			}
			if(fil_mcat.indexOf(mcat)==-1 && mcat!=''){
		       fil_mcat[fil_mcat.length]=mcat;
			}
			if(fil_brnd.indexOf(brnd)==-1 && brnd!=''){
		       fil_brnd[fil_brnd.length]=brnd;
			}
			if(store_id.length>=50)break;
		 }
      
      }
	  if(store_id.length>=50)break;
   }
   if(store_id.length>0){
	   $('.srchresult_txt').html('Similar Brand item/s');
	   create_list(fil_scat, 'sel_scat','');
	   create_list(fil_mcat, 'sel_mcat','');
	   create_list(fil_brnd, 'sel_brnd','');
	   sort_list(store_id);
   }else{
	   $('.srchresult_txt').html('No Items found');
   }
   $('#div_cover1').fadeOut(300);
}


$(document).on('click','.ser-plmin',function(){
   var id = $(this).attr('id').split('_');
   //$('#seritem_'+id[1]).css('background-color','#952882');
   $('#serfld_'+id[1]).css('background-image','url(https://cdn.shopify.com/s/files/1/0270/7157/8246/files/loader2.gif)');
   var varid = $('#lifilter_'+id[1]+' .product-grid-image').attr('href');
   var incr=true;
   if(id[0]=='serbtnrem')incr=false;
   varid = varid.split('/');
   varid= varid[varid.length-1];
   //sel_offer =
   offer_id = $('#lifilter_'+id[1]).find('.cls_offerct').attr('data-id');
   sel_offer = offer_id; 
   $.getJSON('/products/'+varid+'.js', function(product) {
	   addtocartupdateV2(id[1],product.variants[0]['id'],incr)
    });
});
function update_cart_qty(stotal){
   if(updateCrtpos==1){
	  $('.cartCount').click();
	  $('#div_cover1').fadeOut(300);
   }else{
      $('.cls_serfld').css('background-image','none');
   }
   //alert('1 '+ex_items[34748649209990]);
   switch(page){
	   case 'cart' :  
	   $('.qty-group input').css('background-image','none');
       $('.price:eq(1)').text(stotal);
       break;
       case 'product':pro_page_update();
	   break;
       case 'col' : col_update();
	   break;
   }
   mcart_offer_update(stotal);
}
function col_update(){
	//alert('2 '+ex_items[34748649209990]);
   for(var key in updateQty){	
      if(ex_itemsvari_stock[key]!=null && typeof ex_itemsvari_stock[key] != 'undefined'){
	     if(typeof $("[data-tagin-"+key+"]").attr('id') != 'undefined'){
	        var id = $("[data-tagin-"+key+"]").attr('id').split('_');
			 if($('#div_altlist').css('display')=='none'){
		        ex_items[id[1]]=updateQty[key];
			 }
		  }
	   }
	}
	//alert('3 '+ex_items[34748649209990]);
	$('.cls_entqty').css('background-image','none');
	//console.log(offer_items);
	//update_offer_col();
	//sortOffer(false);
}
/*function search_offer(id){
   for(var key in offer_items){
      if(offer_items[key]['vid']==id){
		  return key;
	  }
   }
}*/
function mcart_offer_update(stotal){
   var str,obj,pri;
   //console.log('Mini Cart Update');
   for(var key in offer_items ){
      if(offer_items[key]['qty']>0){
		 obj = $('#cart-item-'+offer_items[key]['vid']);
		 var pri = obj.find('.price').text().substring(1);
	     pri = pri*100;
         str='<div class="mc-offer-box"><div class="cls_offers ';
	     str+='cls_minioffer_'+offer_items[key]['offerid']+' cls_soffer_'+offer_items[key]['offerid']+'" style="display:none" ';
	     str+='data-ip="'+pri+'" data-metaoid="'+offer_items[key]['offerid']+'" dataofid="'+offer_items[key]['vid']+'" ';
	     str+='data-qty="'+offer_items[key]['qty']+'"><input type="hidden" class="cls_eprice" ';
	     str+='value="'+pri+'"/><div>'+offer_head[offer_items[key]['offerid']]+'</div><span></span></div>';
		 obj.append(str);
		 //console.log(str);
	     //console.log(offer_items[key]['vid']+' '+offer_items[key]['qty']);
	  }
	}
	//sortOffer(false);
	
	if(page!='cart'){
		update_offer_qty();
		
	}else{
		cart_offer_update();
		update_offer_dis(stotal);
	}
}
function update_offer_col(){
   if($('#div_altlist').css('display')!='none'){
	   var id = $('#div_altlist').val();
	   //console.log('Staus '+offerCt[id]+' '+id);
	   var tri = parseInt(offerCt[id]['trPoint']);
	   var total = 0;
	   var proid;
	   $('#div_altlist .cls_serfld').each(function(index, element) {
	      proid = $(this).attr('id');
		  proid = proid.split('_');
       });
	   var obj = $('#cart-item-'+sel_varid);
	   var pri = obj.find('.price').text().substring(1);
	   pri = pri*100;
	   var qty = obj.find('.qtt').text();
	   qty = qty.replace(/[^0-9.]/g, "");
	   var msg = calOfferMsg_com(total,tri,id);
	   $('.cls_offmsg_'+id+', .clsoffer_'+id).html(msg);
	   //console.log('clsoffer_ wri 1');
   }
}
function calOfferMsg_com(getQty,srtCnt, oid, y){
	//alert(getQty);
    getQty+=getother_itemqty_com(oid);
	//alert(getQty);
    var z=0;
    var over=false;
    if(getQty>0){
      do {
        getQty = getQty-srtCnt;
        z++;
      } while (z<100 && getQty>=srtCnt);
      if(getQty==0){
        getQty=-1;
      }else if(getQty<0){
        getQty = getQty*-1;
      }else{
        over=true;
        getQty = srtCnt - getQty;  
      }
    }else{
      getQty = srtCnt; 
    }
    if(getQty=='')getQty=srtCnt;
    var tem;
    if(getQty!=-1){
      tem = '+'+getQty+' more to get it'; 
      if(over){
        tem = '+'+getQty+' more to get it again';  
      }
    }else{
      tem='<span style="color:green">You got it</span>';
    }	
    return tem;
  }
  function getother_itemqty_com(oid){
    var cal=0;
    for(var key in offer_items){
      if(oid==offer_items[key]['offerid'] && ex_items_stock[key]==null){
        cal+=parseInt(offer_items[key]['qty']);
      }	
    }
    return cal;
  }
function check_tag_cart(obj){
    var getQty=0;
    var dTotal=0;
    var val,id,pti;
    bof = [];
    //console.log('check_tag_cart');
    $(document).find('.cls_cartoffer_'+obj.id).each(function(index, element) {
      id = $(this).attr('dataofid');
      val = parseInt($(document).find('#updates_'+id).val());
      pri = parseInt($(this).find('.cls_eprice').val());
      dTotal+=pri*val;
      getQty+=val;
	  //console.log('Offer info '+id+' '+val+' '+pri);
      //if(obj.id==2){
      bof[bof.length]={
        'pri':pri,
        'qty':val
      };
      //}
    });
    bof = sortByKeyDesc1(bof,'pri');
    //dTotal = dTotal*getQty;
    var ret = calOfferMsg_cart(getQty,obj.triqty);
    $(document).find('.cls_soffer_'+obj.id+' span').addClass('clsoffer_'+obj.id);
    $(document).find('.cls_soffer_'+obj.id+' span').html(ret['msg']);
    //alert('Dis loop '+ret['cnt']);
    $(document).find('#div_altlist .cls_offmsg_'+obj.id).html(ret['msg']);
    if(ret['cnt']>0){
      //console.log('Discount Apply '+ret['cnt'],dTotal,obj.amt,obj.type,obj.triqty);
      return cal_discount(ret['cnt'],dTotal,obj.amt,obj.type,obj.triqty);
    }
    return 0;
  }
function pro_page_update(){
  if(non_pro_btn){
	for(var key in updateQty){	
	   if(ex_itemsvari_stock[key]!=null && typeof ex_itemsvari_stock[key] != 'undefined'){
		  if(typeof $("[data-tagin-"+key+"]").attr('id') != 'undefined'){
	         var id = $("[data-tagin-"+key+"]").attr('id').split('_');
		     ex_items[id[1]]=updateQty[key];
		  }
		}
	}
	$('.cls_entqty').css('background-image','none');
    non_pro_btn=false;
  }else if($('#myModal').css('display')=='none'){

    $('#myModal .qty-group input').css('background-image','');
    var str ='<span style="color:green; font-size:10px">';
    str+='Added to basket</span>';
    $('#myModal .groups-btn .cls_warmess').html(str);
    $('#myModal .groups-btn .cls_warmess').fadeIn(300,function(){
       setTimeout("$('#myModal .groups-btn .cls_warmess').hide()",1000);
    });
  }
  //alert('Updating....');
  //console.log(obj);
  //sortOffer(false);
  //update_offer_qty();
  //mcart_offer_update();
  $('.cls_offerhid').show();
  /*if($('.qty-group').css('display')=='none'){
     $('.cls_offerhid').hide();
  }else{
	 $('.cls_offerhid').show();
  }*/
}
function update_offer_qty(){
   if(all_offer==null){
	   //console.log('Offer update fail looping ');
	   setTimeout("update_offer_qty()",500);
	   return;
   }
   var obj = JSON.parse(all_offer);
   //console.log('Check Minicart '+all_offer);
   for(var i=0;i<obj.length;i++){
        if(page!='cart'){
		   check_tag(obj[i]);
		}else{
		   check_tag_cart_update(obj[i]);
		}
   }
}
function addtocartupdateV2(id,productId,incr){	
   var obj=$('#serfld_'+id+', [dataid="'+id+'"]');
   var val=parseInt(obj.val());	
   if(!incr){
      val--;
   }else{
	  val++;
   }
   var stock_level = noex_item_stock[id];
   var stock_level = ex_items_stock[id];
 
    if(stock_level==null){
      stock_level=noex_item_stock[id];
	  
      if(offer_items[id]!=null){
        offer_items[id]['qty']=val;
      }else if(typeof oID != "undefined"){
        offer_items[id]={
          'offerid': oID,
          'qty' : val,
		  'vid' :productId
        };
	  }
    }
   var obj1, obj2, obj3, obj4, obj5, obj6;
   obj3=$('#lifilter_'+id);
   obj1 = obj3.find('.cls_warmess');
   obj2 = obj3.find('.cls_btmmess');
   if(!incr){
      Shopify.removeItem(productId, function (cart) {
	     //alert('Removed');
	     if(val<=0){
			//alert('Reset');
	        $('#divser_mul_'+id).hide();
		    $('#divser_new_'+id).show();
		    $('#divser_new_'+id+' .cls_srchaddtocart').html('Add to Cart');
           
           
			$('#div_mul_'+id).hide();
            $('#div_new_'+id).fadeIn(300);            
		    ex_items[id]=0;
		    obj.val(0);
           //halo._captureProductMetaInfo('search_offer', id, true, cart);
           //halo._captureProductMetaInfo('alt_offer', id, true, cart);
		   if(updateQty)updateQty[productId]=0;
		    //update_cart_qty();
		    var str ='Removed from the trolly';
	        obj2.html(str);
			update_cart_qty();
			halo.updateDropdownCart();
	     }else{
	        obj.val(val);
            $('#divser_mul_'+id+' .cls_entqty').val(val);
	        Shopify.addItem(productId,val, function (cart) {
	           halo.updateDropdownCart();
	    	   var str ='<span style="color:#fd7e14">Reduced from the trolly</span>';
	    	   obj2.html(str);
			   ex_items[id]=val;
	        });
	     }
      });
   }else{
      var str
      if(val<=stock_level){
         if(l_item[id]=='' || val<=l_item[id] || l_item[id]=='0' || l_item[id]== null){
    	    obj.val(val);
            $('#divser_mul_'+id+' .cls_entqty').val(val);
            Shopify.addItem(productId,1, function (cart) {
              //halo._captureProductMetaInfo('search_offer', id, true, cart);
              //halo._captureProductMetaInfo('alt_offer', id, true, cart);
    	       halo.updateDropdownCart();
    	       var str ='<span style="color:green">Quantity increased</span>';
    	       obj2.html(str);
			   ex_items[id]=val;
			   //alert('Increased '+ex_items[id]);
    	    });
    	  }else{
             str='<b>Sorry</b><br/>You can\'t add more than '+l_item[id]+' per order';
    		 obj1.html(str);
    		 obj1.fadeIn(300,function(){
    	        setTimeout("$('[data-warm-"+id+"]').fadeOut(300)",1500); 
    	     });
    		 obj.css('background-image','none');
    	  }
      }else{
         str='<b>Sorry</b><br/>Only '+stock_level+' available';
    	 obj1.html(str);
		 obj1.fadeIn(300,function(){
	        setTimeout("$('[data-warm-"+id+"]').fadeOut(300)",1500); 
	     });
    	 obj.css('background-image','none');

      }
	  
   }
}

$(document).on('click','li.close span, .icon-nav',function(){

  $('.cls_searchpop, #div_srcwrd').fadeOut(300);
  $('body').removeClass('openspop');
  $('.nav_up,.cart-side-btn').show();
   halo.updateProductCardUI();
});

ini_tags[0]='Sale';
ini_tags[1]='Oils';
ini_tags[2]='Ghee';
ini_tags[3]='Salt';
ini_tags[4]='Sugar';
ini_tags[5]='Tea';
ini_tags[6]='Coffee';
ini_tags[7]='Rice Products';
ini_tags[8]='Fresh Vegetables';
ini_tags[9]='Leaves';
ini_tags[10]='Exotic Vegetables';
ini_tags[11]='Spinach and Leafy Vegetables';
ini_tags[12]='Fresh Fruits';
ini_tags[13]='Fruits unit';
ini_tags[14]='Tropical Fruit';
ini_tags[15]='Apples';
ini_tags[16]='Stone Fruit';
ini_tags[17]='Chocolates';
ini_tags[18]='Biscuits';
ini_tags[19]='Cake';
ini_tags[20]='Masalas';